import React, { useState, useEffect } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Typography,
  Button,
  Skeleton,
  Paper,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import { getUserConnections } from "../../services/user_Service";
import { getImageUrlAdminToken } from '../../utills/ImagesUtilsAdmin';


const Connections = ({ userId, onBack }) => {
  //console.log("userId", userId);
  const navigate = useNavigate();
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(true);


  console.log("Connnection", connections);

  // Fetch connections data
  const fetchConnections = async () => {
    try {
      const response = await getUserConnections(userId);
      setConnections(response.connections);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);

  };

  useEffect(() => {
    fetchConnections();
  }, [userId]);

  if (loading) {
    return (
      <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
        {[...Array(5)].map((_, index) => (
          <ListItem key={index}>
            <ListItemAvatar>
              <Skeleton variant="circular" width={40} height={40} />
            </ListItemAvatar>
            <ListItemText
              primary={<Skeleton variant="text" width="60%" />}
              secondary={<Skeleton variant="text" width="40%" />}
            />
          </ListItem>
        ))}
      </List>
    );
  }

  return (
    <Paper elevation={0}>
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
        <Typography variant="h6">Connections</Typography>
        <Button variant="outlined" onClick={onBack}>
          Back to Post
        </Button>
      </Box>

      <List
        sx={{
          width: '100%',
          bgcolor: 'background.paper',
          maxHeight: 'calc(100vh - 200px)',
          overflow: 'auto',
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'rgba(0,0,0,0.1)',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,0.2)',
            borderRadius: '4px',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.3)',
            },
          },
        }}
      >
        {connections.map((connection) => (
          <ListItem
            key={connection.id}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.04)',
              },
            }}
          >
            <ListItemAvatar>
              <Avatar
                src={getImageUrlAdminToken(connection.thumbnail_pic)}
                alt={connection.name}
                // navigate to profile page on click
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate(`/users/${connection.id}`)}
              />
            </ListItemAvatar>
            <ListItemText
              primary={connection.name}
              secondary={
                <>
                  <Typography
                    component="span"
                    variant="body2"
                    color="text.secondary"
                    sx={{ display: 'block' }}
                  >
                    {connection.describes_me}
                  </Typography>
                </>
              }
            />
            {/* <Button
              variant="text"
              color="primary"
              onClick={() =>}
              sx={{ ml: 2 }}
            >
              View Profile
            </Button> */}
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default Connections;